import React from 'react'
import styled from 'styled-components'

const QuestionListItemTitleWrapperUi = styled.div`
  flex: 1;
`

const QuestionListItemTitleUi = styled.span<{ isEmpty?: boolean }>`
  border-bottom: 1px dashed var(--default-text-color);
  font-size: 20px;
  cursor: pointer;
  ${({ isEmpty }) => isEmpty && 'opacity: 0.5; font-style: italic;'}
`

type QuestionListItemTitleProps = {
  children: string
  placeholder?: string
  onClick: (e: React.SyntheticEvent) => void
}

export const QuestionListItemTitle = ({
  children,
  placeholder,
  onClick,
}: QuestionListItemTitleProps) => {
  const isEmpty = !children
  return (
    <QuestionListItemTitleWrapperUi>
      <QuestionListItemTitleUi onClick={onClick} isEmpty={isEmpty}>
        {children || placeholder}
      </QuestionListItemTitleUi>
    </QuestionListItemTitleWrapperUi>
  )
}
